import { action, makeObservable, observable } from 'mobx';

class DocumentStore {
    constructor() {
        makeObservable(this)
    }

    @observable loadingItemStatus: boolean = false;
    @action setLoadingItemStatus(status: boolean) {
        this.loadingItemStatus = status;
    }

    // Document Datas
    @observable documentDatas = {};

    @action addDocumentData(documentId: number, documentData: any) {
        this.documentDatas[documentId] = documentData;
    }

    @action updateDocumentData(documentId: number, documentData: any) {
        this.documentDatas[documentId] = documentData;
    }
    // Document Datas

    // Documents
    @observable documents = {
        content: {},
        page: 1,
        pageCount: 1,
    }

    @action resetDocuments() {
        this.documents = {
            content: {},
            page: 1,
            pageCount: 1,
        };
    }

    @action setDocuments(documents: any) {
        this.documents['content'] = documents;
    }

    @action setPaginationData(page: number, pageCount: number) {
        this.documents = {
            ...this.documents,
            page,
            pageCount,
        };
    }

    @action addDocument(documentId: number, documentData: any) {
        if (this.documents['content'][documentId] === undefined) {
            this.documents['content'][documentId] = documentData;
        }

        if (this.documentDatas[documentId] === undefined) {
            this.documentDatas[documentId] = documentData;
        }
    }

    @action updateDocument(documentId: number, documentData: any) {
        if (this.documents['content'][documentId] !== undefined) {
            this.documents['content'][documentId] = documentData;
        }

        if (this.documentDatas[documentId] !== undefined) {
            this.documentDatas[documentId] = documentData;
        }
    }

    @action deleteDocument(documentId: number) {
        delete this.documents['content'][documentId];
    }
    // Documents

    // Search Documents
    @observable searchDocuments = {
        content: {},
        page: 1,
        pageCount: 1,
    };

    @action setSearchDocuments(searchDocuments: any) {
        this.searchDocuments = searchDocuments;
    }

    @action resetSearchDocuments() {
        this.searchDocuments = {
            content: {},
            page: 1,
            pageCount: 1,
        };
    }

    @action setSearchPaginationData(page: number, pageCount: number) {
        this.searchDocuments = {
            ...this.searchDocuments,
            page,
            pageCount,
        };
    }

    @action addSearchDocument(documentId: number, documentData: any) {
        this.searchDocuments.content[documentId] = documentData;
    }

    @action deleteSearchDocument(documentId: number) {
        if (this.searchDocuments.content[documentId] !== undefined) {
            delete this.searchDocuments.content[documentId];
        }
    }

    @observable searchFilterText = "";
    @action setSearchFilterText(filterText: string) {
        this.searchFilterText = filterText;
    }
    // Search Documents
}

const store = new DocumentStore();

export default store;